<template>
  <div
    class="w-100"
    v-bind:style="
      ParentCode.toString().length >= 3 ? 'padding: 5px 5px 5px 0px;' : ''
    "
  >
    <table
      class="table table-bordered text-center table-font-size bg-white m-0"
    >
      <!-- سربرگ جدول -->
      <thead class="text-light" v-bind:style="getColorHead">
        <td
          colspan="5"
          style="padding: 10px 0 !important"
          v-bind:style="getHeaderTableFontSize"
        >
          {{ getHeaderTable }}
          <span
            title="تعداد زیر مجموعه"
            class="mr-2"
            style="font-size: 14px !important"
            v-if="this.ParentCode.toString().length < 3"
          >
            ( <i class="fas fa-share-alt fa-rotate-90"></i>
            {{ this.getListChildLastLevel(this.ParentCode).length }} )
          </span>
        </td>
      </thead>
      <!-- بدنه جدول -->
      <tbody>
        <template v-for="row in getListTabagheBandiAmaliyati">
          <tr
            :key="row.NPerID"
            v-bind:id="row.NPerID"
            :style="
              getListChildLastLevel(row.SPerNationalId).length > 0
                ? 'cursor: pointer'
                : 'cursor: no-drop'
            "
            class="border-1"
            :class="{ selRow: SearchToListAllShow(row.SPerNationalId) == true }"
          >
            <!-- فلش جهت نما -->
            <td
              style="
                width: 50px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding-left: 5px !important;
                padding-right: 5px !important;
              "
              v-on:click="SaveRowSelect(row)"
            >
              <!-- منوی مشاهده فرزندان -->
              <a
                href="#"
                v-bind:title="'مشاهده ' + getTitleNewTabagheBandi + '‌ها'"
                v-if="getListChildLastLevel(row.SPerNationalId).length > 0"
              >
                <i
                  v-if="SearchToListAllShow(row.SPerNationalId) == false"
                  class="far fa-folder fa-1x-half m-1 text-primary"
                ></i>
                <i
                  v-else
                  class="far fa-folder-open fa-1x-half m-1 text-primary"
                ></i>
              </a>
              <i
                v-else
                class="fas fa-folder-minus fa-1x-half m-1 text-primary"
              ></i>
            </td>
            <!-- کد حساب -->
            <td
              style="
                width: 70px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              "
              v-bind:style="
                ParentCode.toString().length < 7
                  ? 'font-size: 14px !important; font-weight: bold !important;'
                  : ''
              "
              v-on:click="SaveRowSelect(row)"
            >
              {{ row.SPerNationalId }}
            </td>
            <!-- عنوان حساب -->
            <td
              style="
                text-align: right !important;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding: 10px !important;
              "
              v-bind:style="
                ParentCode.toString().length < 7
                  ? 'font-size: 14px !important; font-weight: bold !important;'
                  : ''
              "
              v-on:click="SaveRowSelect(row)"
            >
              <div
                class="d-flex justify-content-between align-items-center w-100"
              >
                <span>
                  {{ row.NPerName + " " + row.NPerLastName }}
                </span>
                <span
                  class="text-black-50"
                  title="تعداد زیر مجموعه"
                  v-if="TabagheBandiType == 1 ? row.SPerNationalId.toString().length <= 7 : row.SPerNationalId.toString().length < 5"
                >
                  <i class="fas fa-share-alt fa-rotate-90"></i>
                  {{ getListChildLastLevel(row.SPerNationalId).length }}
                </span>
              </div>
            </td>
            <td>
              {{ row.NPerName }}
            </td>
            <!-- مدیریت -->
            <td
              style="
                width: 120px !important;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                padding-left: 5px !important;
                padding-right: 5px !important;
              "
            >
              <!-- منوی حذف سرفصل حساب -->
              <a
                href="#"
                title="حذف سرفصل حساب"
                v-on:click="DeleteTabagheBandiAmaliyatiRow(row)"
                v-if="getListChildLastLevel(row.SPerNationalId).length == 0"
              >
                <i class="far fa-trash-alt fa-1x-half m-1 text-danger"></i>
              </a>
              <i
                v-else
                style="cursor: auto; color: #d3d2d2"
                class="far fa-trash-alt fa-1x-half m-1"
              ></i>
              <!-- منوی ویرایش سرفصل حساب -->
              <a
                href="#"
                title="ویرایش طبقه بندی عملیاتی"
                data-toggle="modal"
                v-bind:data-target="'#ModalEditTabagheBandiAmaliyati-' + row.SPerNationalId
                "
                v-on:click="ShowModalEditTabagheBandi(row)"
              >
                <i class="fas fa-edit fa-1x-half m-1 text-primary"></i>
              </a>
              <!-- منوی افزودن سرفصل جدید -->
              <a
                href="#"
                v-bind:title="'افزودن ' + getTitleNewTabagheBandi + ' جدید'"
                data-toggle="modal"
                v-bind:data-target="
                  '#ModalAddNewTabagheBandiAmaliyati-' + row.SPerNationalId
                "
                v-on:click="ShowModalAddNewTabagheBandiAmaliyati(row)"
                v-if="TabagheBandiType == 1 ? row.SPerNationalId.toString().length <= 7 : row.SPerNationalId.toString().length < 5"
              >
                <i class="far fa-clone fa-1x-half m-1 text-default"></i>
              </a>
            </td>
          </tr>
          <!-- نمایش سرفصل های فرزند به صورت فراخوانی بازگشتی -->
          <tr
            v-if="
              SearchToListAllShow(row.SPerNationalId) == true &&
              getListChildLastLevel(row.SPerNationalId).length > 0
            "
            :key="'docRows' + row.NPerID"
          >
            <td
              style="
                writing-mode: vertical-rl;
                font-size: 14px !important;
                padding: 10px 10px !important;
              "
            >
              {{ row.NPerName + " " + row.NPerLastName }}
            </td>
            <td
              colspan="4"
              style="padding: 5px !important; background-color: #f1fdff"
            >
              <ShowTableTabagheBandiAmaliyati
                :key="row.SPerNationalId"
                v-bind:ParentCode="row.SPerNationalId"
                v-bind:TabagheBandiType="TabagheBandiType"
                v-bind:ListTabagheBandiAmaliyatiData="
                  getListAllChild(row.SPerNationalId)
                "
                v-bind:isMultieSelect="isMultieSelect"
                v-bind:ListAllShowFilter="ListAllShowFilter"
              ></ShowTableTabagheBandiAmaliyati>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <!-- مودال ثبت سرفصل حساب جدید -->
    <AddNewTabagheBandiAmaliyati
      v-if="isShowModalAddNew == true"
      v-on:HideModalAddNewTabagheBandiAmaliyati="
        HideModalAddNewTabagheBandiAmaliyati
      "
      v-bind:ParentCode="SelectRowData.SPerNationalId"
      v-bind:NewChildCode="NewChildCode"
      v-bind:NPerType="getNPerTypeNewTabagheBandi(SelectRowData.NPerType)"
      v-bind:NPerName="getTitleNewTabagheBandi"
      v-bind:Title1="'ثبت ' + getTitleNewTabagheBandi + ' جدید'"
      v-bind:Title2="
        'حساب والد : ' +
        SelectRowData.SPerNationalId +
        ' - ' +
        SelectRowData.NPerName +
        ' ' +
        SelectRowData.NPerLastName
      "
    ></AddNewTabagheBandiAmaliyati>

    <!-- مودال ویرایش اطلاعات سرفصل حساب -->
      <!-- v-if="isShowEditTabagheBandi == true" -->
    <EditTabagheBandiAmaliyati
      v-on:HideModalEditTabagheBandi="HideModalEditTabagheBandi"
      v-bind:RowTabagheBandiData="EditListTabagheBandiAmaliyati"
      v-bind:Title1="'ویرایش اطلاعات ' + EditListTabagheBandiAmaliyati.NPerName"
    ></EditTabagheBandiAmaliyati>
  </div>
</template>

<script>
import AddNewTabagheBandiAmaliyati from "./AddNewTabagheBandiAmaliyati.vue";
import EditTabagheBandiAmaliyati from "./EditTabagheBandiAmaliyati.vue";

export default {
  name: "ShowTableTabagheBandiAmaliyati", // در فراخوانی بازگشتی نام باید هم نام کامپاننت باشد
  props: [
    "ParentCode", // کد والد
    "TabagheBandiType", // نوع طبقه بندی : پروژه یا خدمت
    "ListTabagheBandiAmaliyatiData", // اطلاعات ورودی به کامپاننت
    "isMultieSelect", // کنترل وضعیت چند انتخابی
    "ListAllShowFilter", // اطلاعات تمام سطرهای در حال نمایش
  ],
  components: {
    AddNewTabagheBandiAmaliyati,
    EditTabagheBandiAmaliyati,
  },
  data() {
    return {
      LocalTabagheBandiAmaliyatiData: [], // لیست محلی سرفصل حساب ها
      // اطلاعات سطر در حال انتخاب
      SelectRowData: {},
      // اطلاعات تمام سطرهای در حال نمایش
      ListAllShow: [],
      // اطلاعات طبقه بندی عملیاتی جهت ویرایش اطلاعات
      // اطلاعات طبقه بندی عملیاتی نیز در جدول پرسنل نگهداری می گردد
      EditListTabagheBandiAmaliyati: {
        NUserCode: 1, // کد کاربر مدیر
        NPerID: 0, // کد یکتا سطر
        SPerNationalId: 0, //  کد طبقه بندی علمیاتی
        NPerTaxNu: "", // خالی
        NPerNationalType: 1, // 1
        NPerType: 4, // کد نوع : 4 ماموریت - 5 برنامه - 6 طرح - 7 خدمت - 8 پروژه
        NPerTaxType: 5, // 5
        NPerName: "ماموریت", // نام نوع : ماموریت - برنامه - طرح - خدمت - پروژه
        NPerLastName: "", // عنوان طبقه بندی عملیاتی
        NPerProvinceCode: 10, // کد استان
        NPerCityCode: 1001000, // کد شهر
        NPerAddress: "", // خالی
        NPerTelCode: "", // خالی
        NPerTel: "", // خالی
        NPerPostcalCode: "", // خالی
        NPerKalaType: 12, // 12
        SDate: "", // تاریخ ثبت
        DTime: "", // ساعت ثبت
        SJob: "", // خالی
        SShopName: "", // خالی
        SMobileNu: "", // خالی
        SFaxNu: "", // خالی
        SAccNu: "", // خالی
        SAccCardNu: "", // خالی
        SAccIRNu: "", // خالی
        NAccBank: 0, // 0
        NPerFatherName: "", // خالی
        NYear: "", // سال
        NGroup: 0, // 0
        NPerIDPay: 0, // 0
      },
      // کنترل وضعیت نمایش مودال ثبت جدید
      isShowModalAddNew: false,
      // کد سطر جدید
      NewChildCode: 0,
      // کد نوع سطر جدید
      NewNAccType: 0,
      // کنترل وضعیت نمایش مودال ویرایش اطلاعات
      isShowEditTabagheBandi: false,
    };
  },
  computed: {
    getListTabagheBandiAmaliyati() {
      // بررسی وضعیت جستجو
      if (
        this.ListAllShowFilter != undefined &&
        this.ListAllShowFilter.length > 0
      ) {
        this.ListAllShow = this.ListAllShowFilter;
      }

      let tempSPerNationalId = new String(this.ParentCode);
      if (this.ListTabagheBandiAmaliyatiData.length > 0) {
        if (tempSPerNationalId != 0) {
          if (tempSPerNationalId.length == 1) {
            // انتخاب سطح دو : برنامه ها
            this.LocalTabagheBandiAmaliyatiData =
              this.ListTabagheBandiAmaliyatiData.filter(function (item) {
                return (
                  item.SPerNationalId != tempSPerNationalId &&
                  item.SPerNationalId.toString().length == 3 &&
                  item.SPerNationalId.toString().substring(
                    0,
                    tempSPerNationalId.length
                  ) == tempSPerNationalId
                );
              });
          } else if (
            tempSPerNationalId.length >= 3 &&
            tempSPerNationalId.length < 5
          ) {
            // انتخاب سطح سه : طرح ها یا خدمت ها
            this.LocalTabagheBandiAmaliyatiData =
              this.ListTabagheBandiAmaliyatiData.filter(function (item) {
                return (
                  item.SPerNationalId.toString().length ==
                    parseInt(tempSPerNationalId.length) + 2 &&
                  item.SPerNationalId.toString().substring(
                    0,
                    tempSPerNationalId.length
                  ) == tempSPerNationalId
                );
              });
          } else if (tempSPerNationalId.length >= 5) {
            // انتخاب سطح چهار : پروژه ها
            this.LocalTabagheBandiAmaliyatiData =
              this.ListTabagheBandiAmaliyatiData.filter(function (item) {
                return (
                  item.SPerNationalId.toString().length ==
                    parseInt(tempSPerNationalId.length) + 3 &&
                  item.SPerNationalId.toString().substring(
                    0,
                    tempSPerNationalId.length
                  ) == tempSPerNationalId
                );
              });
          }
        } else {
          // انتخاب سطح یک : ماموریت ها
          this.LocalTabagheBandiAmaliyatiData =
            this.ListTabagheBandiAmaliyatiData.filter(function (item) {
              return item.SPerNationalId.toString().length == 1;
            });
        }
      }

      return this.LocalTabagheBandiAmaliyatiData;
    },
    // ایجاد سایز فونت سربرگ جدول
    getHeaderTableFontSize() {
      let strHeader = "";
      if (this.ParentCode.toString().length < 3) {
        strHeader = "font-size: 18px !important;";
      } else if (
        this.ParentCode.toString().length >= 3 &&
        this.ParentCode.toString().length < 5
      ) {
        strHeader = "font-size: 17px !important;";
      } else if (
        this.ParentCode.toString().length >= 5 &&
        this.ParentCode.toString().length < 7
      ) {
        strHeader = "font-size: 16px !important;";
      } else if (this.ParentCode.toString().length >= 7) {
        strHeader = "font-size: 15px !important;";
      } else {
        strHeader = "font-size: 14px !important; font-weight: bold !important;";
      }
      return strHeader;
    },
    // ایجاد سربرگ جدول
    getHeaderTable() {
      let strHeader = "";

      if (this.ParentCode == 0) {
        strHeader = "لیست ماموریت‌ها";
      } else if (this.ParentCode.toString().length == 1) {
        strHeader = "لیست برنامه‌ها";
      } else if (this.ParentCode.toString().length == 3) {
        strHeader = this.TabagheBandiType == 1 ? "لیست طرح‌ها" : "لیست خدمت‌ها";
      } else if (this.ParentCode.toString().length >= 5) {
        strHeader = "لیست پروژه‌ها";
      }
      return strHeader;
    },
    // دریافت عنوان طبقه بندی عملیاتی برای ویرایش
    getTitleEditBaseAcc() {
      let strHeader = "";
      if (this.ParentCode.toString().length < 3) {
        strHeader = "ماموریت";
      } else if (
        this.ParentCode.toString().length >= 3 &&
        this.ParentCode.toString().length < 5
      ) {
        strHeader = "برنامه";
      } else if (
        this.ParentCode.toString().length >= 5 &&
        this.ParentCode.toString().length < 7
      ) {
        strHeader = this.TabagheBandiType == 1 ? "طرح" : "خدمت";
      } else if (this.ParentCode.toString().length >= 7) {
        strHeader = "پروژه";
      }
      return strHeader;
    },
    // ایجاد رنگ سربرگ
    getColorHead() {
      let strHeader = "";
      if (this.ParentCode.toString().length < 3) {
        strHeader = "background-color: #9933CC;";
      } else if (
        this.ParentCode.toString().length >= 3 &&
        this.ParentCode.toString().length < 5
      ) {
        strHeader = "background-color: #0277bd ";
      } else if (
        this.ParentCode.toString().length >= 5 &&
        this.ParentCode.toString().length < 7
      ) {
        strHeader = "background-color: #0288d1";
      } else if (this.ParentCode.toString().length >= 7) {
        strHeader = "background-color: #039be5";
      }
      return strHeader;
    },

    // دریافت عنوان طبقه بندی عملیاتی برای درج جدید
    getTitleNewTabagheBandi() {
      let parentCode = this.ParentCode;
      let strHeader = "";
      if (parentCode == 0) {
        strHeader = "برنامه";
      } else if (parentCode.toString().length < 3) {
        strHeader = this.TabagheBandiType == 1 ? "طرح" : "خدمت";
      } else if (parentCode.toString().length >= 3) {
        strHeader = "پروژه";
      }
      return strHeader;
    },
  },
  methods: {
    // دریافت نوع طبقه بندی علمیاتی برای درج جدید
    getNPerTypeNewTabagheBandi(NPerType) {
      if (NPerType == 4) return 5;
      else if (NPerType == 5) return this.TabagheBandiType == 1 ? 6 : 7;
      // پروژه : 1 - خدمت : 2
      else if (NPerType == 6) return 8;
    },

    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(RowSelect) {
      this.SelectRowData = RowSelect;
      if (this.SearchToListAllShow(RowSelect.SPerNationalId) == false) {
        // افزودن به لیست تمام سطرهای در حال نمایش
        this.SaveListAllShow(RowSelect.SPerNationalId);
      } else {
        // حذف از لیست تمام سطرهای در حال نمایش
        this.DeleteFromListAllShow(RowSelect.SPerNationalId);
      }
    },

    // نگهداری اطلاعات تمام سطرهای در حال نمایش
    SaveListAllShow(SPerNationalId) {
      // آیا وضعیت چند انتخابی فعال است ؟
      if (this.isMultieSelect == true) {
        // مقدارد دهی به لیست
        this.ListAllShow.push(SPerNationalId);
      } else {
        // خالی کردن لیست
        this.ListAllShow.length = 0;
        // مقدار دهی به لیست
        this.ListAllShow.push(SPerNationalId);
      }
    },

    // حذف یک آیتم از لیست تمام سطرهای در حال نمایش
    DeleteFromListAllShow(SPerNationalId) {
      this.ListAllShow = this.ListAllShow.filter(function (value) {
        return value != SPerNationalId;
      });
    },
    
    // جستجو در لیست تمام سطرهای در حال نمایش
    SearchToListAllShow(SPerNationalId) {
      if (this.ListAllShow.length > 0) {
        let index = this.ListAllShow.findIndex((item) => item == SPerNationalId);
        if (index != -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // تابع نمایش مودال درج سرفصل جدید
    ShowModalAddNewTabagheBandiAmaliyati(RowData) {
      if (RowData.SPerNationalId != this.SelectRowData.SPerNationalId) {
        this.SaveRowSelect(RowData);
      }
      this.NewChildCode = this.getLastChildCode(RowData.SPerNationalId);
      this.isShowModalAddNew = true;
    },

    // تابع نمایش مودال ویرایش اطلاعات سرفصل حساب
    ShowModalEditTabagheBandi(row) {
      // نگهداری اطلاعات سطری که مورد ویرایش قرار گرفته است
      this.EditListTabagheBandiAmaliyati = row
      // نمایش مودال ویرایش
      this.isShowEditTabagheBandi = true;
    },

    // استخراج لیست تمام فرزندان
    // جهت پاس دادن لیست تمام فرزندان به کامپاننت فرزند (فراخوانی بازگشتی)
    getListAllChild(ParentCode) {
      let tempData = this.ListTabagheBandiAmaliyatiData.filter(function (item) {
        return (
          item.SPerNationalId.toString().length > ParentCode.length &&
          item.SPerNationalId.toString().substring(0, ParentCode.length) ==
            ParentCode
        );
      });
      return tempData;
    },

    // استخراج کد آخرین فرزند جهت درج سطر جدید
    getLastChildCode(SPerNationalId) {
      let tempCode = 0;
      this.getListChildLastLevel(SPerNationalId).forEach((element) => {
        if (element.SPerNationalId > tempCode) {
          tempCode = element.SPerNationalId;
        }
      });
      if (parseInt(tempCode) > 0) {
        // افزایش یک واحدی کد آخرین فرزند
        return (parseInt(tempCode) + 1).toString();
      } else {
        // فرزندی یافت نشد / صدور کد جدید / تفصیلی سه صفر یک
        return (
          SPerNationalId +
          (SPerNationalId.toString().length >= 5 ? "001" : "01")
        ).toString();
      }
    },

    // استخراج فرزندان سطح بعدی
    // آیا گره انتخابی در سطح بعدی فرزندی دارد ؟
    // کنترل حذف - نمایش تعداد فرزندان - استخراج کد آخرین فرزند
    getListChildLastLevel(SPerNationalId) {
      let tempSPerNationalId = new String(SPerNationalId);
      let tempData = [];
      if (this.ListTabagheBandiAmaliyatiData.length > 0) {
        if (tempSPerNationalId != 0) {
          if (tempSPerNationalId.length == 1) {
            // انتخاب سطح دو : برنامه ها
            tempData = this.ListTabagheBandiAmaliyatiData.filter(function (
              item
            ) {
              return (
                item.SPerNationalId != tempSPerNationalId &&
                item.SPerNationalId.toString().length == 3 &&
                item.SPerNationalId.toString().substring(
                  0,
                  tempSPerNationalId.length
                ) == tempSPerNationalId
              );
            });
          } else if (
            tempSPerNationalId.length >= 3 &&
            tempSPerNationalId.length < 5
          ) {
            // انتخاب سطح سه : طرح ها یا خدمت ها
            tempData = this.ListTabagheBandiAmaliyatiData.filter(function (
              item
            ) {
              return (
                item.SPerNationalId.toString().length ==
                  parseInt(tempSPerNationalId.length) + 2 &&
                item.SPerNationalId.toString().substring(
                  0,
                  tempSPerNationalId.length
                ) == tempSPerNationalId
              );
            });
          } else if (tempSPerNationalId.length >= 5) {
            // انتخاب سطح چهار : پروژه ها
            tempData = this.ListTabagheBandiAmaliyatiData.filter(function (
              item
            ) {
              return (
                item.SPerNationalId.toString().length ==
                  parseInt(tempSPerNationalId.length) + 3 &&
                item.SPerNationalId.toString().substring(
                  0,
                  tempSPerNationalId.length
                ) == tempSPerNationalId
              );
            });
          }
        } else {
          // انتخاب سطح یک : ماموریت ها
          tempData = this.ListTabagheBandiAmaliyatiData.filter(function (item) {
            return item.SPerNationalId.toString().length == 1;
          });
        }
      }
      return tempData;
    },

    // رویداد بسته شدن مودال ثبت طبقه بندی جدید
    HideModalAddNewTabagheBandiAmaliyati() {
      // مخفی کردن مودال ثبت طبقه بندی جدید
      this.isShowModalAddNew = false;
    },

    // رویداد بسته شدن مودال ویرایش اطلاعات سرفصل حساب
    HideModalEditTabagheBandi() {
      // مخفی کردن مودال ویرایش اطلاعات سرفصل حساب
      this.isShowEditTabagheBandi = false;
    },

    // تابع حذف طبقه بندی عملیاتی از لیست
    DeleteTabagheBandiAmaliyatiRow(row) {
      if (this.getListChildLastLevel(row.SPerNationalId).length == 0) {
        swal({
          title: "تقاضای حذف " + row.NPerName,
          text:
            "آیا " +
            row.NPerName +
            " ( " +
            row.SPerNationalId +
            " - " +
            row.NPerName +
            " " +
            row.NPerLastName +
            " ) حذف شود ؟",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "انصراف",
            ok: "بله این " + row.NPerName + " حذف شود",
          },
        }).then(async (value) => {
          if (value) {
            // نمایش لطفا صبر نمایید
            this.$store.dispatch("pleaseWait", {
              notText: "حذف طبقه بندی عملیاتی از سرور",
            });
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // ارسال تقاضای حذف سرفصل حساب به سرور
            await this.$store.dispatch("DeleteTabagheBandiAmaliyatiToServer", {
              DeleteTabagheBandiData: row,
              token: token,
            });
            // لغو نمایش لطفا صبر نمایید
            this.$store.dispatch("pleaseWait", {
              stop: true,
            });
          }
        });
      } else {
        // مجاز به حذف سرفصل حساب دارای فرزند نمی باشید
        swal({
          title: "عدم حذف سرفصل حساب",
          text: "شما مجاز به حذف سرفصل حساب دارای فرزند نمی باشید .",
          icon: "warning", // success, warning, error, info
          buttons: {
            cancel: "بله متوجه شدم",
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListTabagheBandiAmaliyati/Components/ShowTableTabagheBandiAmaliyati.vue